import { render } from "./Index_affix_m.vue?vue&type=template&id=0222159e"
import script from "./Index_affix_m.vue?vue&type=script&lang=js"
export * from "./Index_affix_m.vue?vue&type=script&lang=js"

import "./Index_affix_m.vue?vue&type=style&index=0&id=0222159e&lang=css"
script.render = render

export default script